<template>
   <div v-if="show" class="secondary-total" :class="{ 'is-print': print }" data-secondary-total>
      <span class="secondary-total-label">{{ $t(currency == 'dollar' ? 'lang_equivalent_total_iqd' : 'lang_equivalent_total_usd') }}</span>
      <strong class="secondary-total-value" dir="ltr">&asymp; {{ formatted }}</strong>
      <small v-if="showRate" class="secondary-total-rate" dir="ltr">1 $ = {{ $filters.setCurrency(rate, 'dinar') }}</small>
   </div>
</template>

<script>
import { computed } from 'vue';
import { convertAmount, altCurrency, normalizeRate } from '@/utils/pricing';

// Auxiliary grand total: the invoice total converted to the other currency with the rate saved for that invoice.
export default {
   props: {
      total:    { type: [Number, String], default: 0 },
      currency: { type: String, default: 'dinar' },
      rate:     { type: [Number, String], default: 0 },
      print:    { type: Boolean, default: false },
      showRate: { type: Boolean, default: true },
   },

   setup(props) {
      const rateValue = computed(() => normalizeRate(props.rate));
      const amount    = computed(() => convertAmount(props.total, props.currency, rateValue.value));
      const show      = computed(() => rateValue.value > 0 && parseFloat(props.total) != 0 && !isNaN(parseFloat(props.total)));

      return { show, amount, formatted: computed(() => formatAmount(amount.value, altCurrency(props.currency))) };
   },
}

function formatAmount(number, currency) {
   const lang = getCookie('vue_diamond_pos_lang');

   if (currency == 'dollar') return number.toLocaleString('en-US') + ' $';

   return number.toLocaleString('en-US') + ' ' + (lang == 'en' ? 'IQD' : 'د.ع');
}
</script>

<style lang="scss" scoped>
.secondary-total {
   display: flex;
   flex-direction: column;
   gap: .15rem;
   padding: .5rem .75rem;
   margin-top: .75rem;
   border: 1px dashed var(--dark-gray, #999);
   border-radius: .35rem;
   background: #fff;
   color: #222;

   .secondary-total-label { font-size: .8rem; opacity: .8; }
   .secondary-total-value { font-size: 1rem; }
   .secondary-total-rate  { font-size: .7rem; opacity: .6; }

   &.is-print {
      margin: .5rem 0 1rem;
      border: 1px solid #000;
      border-radius: 0;
      color: #000;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: baseline;
      break-inside: avoid;

      .secondary-total-label { font-size: 1rem; opacity: 1; font-weight: bold; }
      .secondary-total-value { font-size: 1.1rem; }
      .secondary-total-rate  { width: 100%; font-size: .75rem; opacity: .8; }
   }
}
</style>
